import React from 'react';
import { Table, Button } from 'react-bootstrap';
import type { BannerListProps } from './types';
import MediaPreview, { MediaErrorOverlay } from './MediaPreview';
import { formatISODateTimeToUTC } from '../../../../../utils/dateUtils';

const BannerList: React.FC<BannerListProps> = ({
  banners,
  imageLoadErrors,
  handleImageError,
  handleEdit,
  handleDelete,
  handleImagePreview,
}) => {
  return (
    <Table responsive bordered hover className="align-middle">
      <thead className="bg-light">
        <tr>
          <th style={{ width: '60px' }}>Order</th>
          <th style={{ width: '120px' }}>Desktop</th>
          <th style={{ width: '120px' }}>Tablet</th>
          <th style={{ width: '120px' }}>Mobile</th>
          <th>Title</th>
          <th>Description</th>
          <th>From Date</th>
          <th>To Date</th>
          <th>Banner Location</th>
          <th>Link URL</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {banners.map((banner) => (
          <tr key={banner.bannerId}>
            <td className="text-center">
              <span className="badge bg-primary">{banner.order}</span>
            </td>
            <td>
              <div style={{ position: 'relative' }}>
                <MediaPreview
                  imageUrl={banner.imageUrl}
                  title={banner.title}
                  deviceType="desktop"
                  bannerId={banner.bannerId}
                  onImageError={handleImageError}
                  onImageClick={handleImagePreview}
                />
                {imageLoadErrors[banner.bannerId] && <MediaErrorOverlay />}
              </div>
            </td>
            <td>
              <div style={{ position: 'relative' }}>
                <MediaPreview
                  imageUrl={banner.tabletImageUrl}
                  title={banner.title}
                  deviceType="tablet"
                  bannerId={banner.bannerId}
                  onImageError={handleImageError}
                  onImageClick={handleImagePreview}
                />
                {imageLoadErrors[`${banner.bannerId}-tablet`] && <MediaErrorOverlay />}
              </div>
            </td>
            <td>
              <div style={{ position: 'relative' }}>
                <MediaPreview
                  imageUrl={banner.mobileImageUrl}
                  title={banner.title}
                  deviceType="mobile"
                  bannerId={banner.bannerId}
                  onImageError={handleImageError}
                  onImageClick={handleImagePreview}
                />
                {imageLoadErrors[`${banner.bannerId}-mobile`] && <MediaErrorOverlay />}
              </div>
            </td>
            <td>{banner.title}</td>
            <td>{banner.description}</td>
            <td>{banner.fromDate ? formatISODateTimeToUTC(banner.fromDate) : '-'}</td>
            <td>{banner.toDate ? formatISODateTimeToUTC(banner.toDate) : '-'}</td>
            <td>{banner.location}</td>
            <td>
              {banner.linkUrl ? (
                <a href={banner.linkUrl} target="_blank" rel="noopener noreferrer" title={banner.linkUrl}>
                  {banner.linkUrl.length > 50 ? banner.linkUrl.substring(0, 50) + '...' : banner.linkUrl}
                </a>
              ) : (
                <span className="text-muted">-</span>
              )}
            </td>
            <td>
              {banner.active ? (
                <span className="badge bg-success">Active</span>
              ) : (
                <span className="badge bg-secondary">Inactive</span>
              )}
            </td>
            <td>
              <div className="d-flex gap-2">
                <Button variant="outline-primary" size="sm" onClick={() => handleEdit(banner)}>
                  Edit
                </Button>
                <Button variant="danger" size="sm" onClick={() => handleDelete(banner.bannerId)}>
                  Delete
                </Button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default BannerList;
